import type { VegaLiteVisualization } from '@terra/shared-dto-chat-types';

export type VegaLiteJsonObject = Record<string, unknown>;

export type VegaLiteEmbedSpec = VegaLiteJsonObject;

export function isVegaLiteJsonObject(
  value: unknown,
): value is VegaLiteJsonObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isVegaLiteVisualizationPayload(
  value: unknown,
): value is VegaLiteVisualization {
  if (!isVegaLiteJsonObject(value)) {
    return false;
  }

  if (value.type !== 'vega_lite_visualization') {
    return false;
  }

  return (
    typeof value.title === 'string' &&
    value.title.length > 0 &&
    (value.scopeLabel === undefined || typeof value.scopeLabel === 'string') &&
    isVegaLiteJsonObject(value.spec)
  );
}

export function toVegaLiteEmbedSpec(
  spec: VegaLiteJsonObject,
): VegaLiteEmbedSpec {
  return spec;
}
